import { render, staticRenderFns } from "./LangMenu.vue?vue&type=template&id=54115bd6&scoped=true"
import script from "./LangMenu.vue?vue&type=script&lang=js"
export * from "./LangMenu.vue?vue&type=script&lang=js"
import style0 from "./LangMenu.vue?vue&type=style&index=0&id=54115bd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54115bd6",
  null
  
)

export default component.exports